import React from 'react'
import HodNav from './HodNav'
import GetHODForm from './GetHODForm'

export default function Hod() {
  return (
    <div>
        <HodNav/>
        <GetHODForm/>
    </div>
  )
}
